/* Start News */
export const validatnews = (inputs) => {
    const errors = {};
    if (!inputs.news_email) {
      errors.news_email = 'Please enter your email';
    }else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputs.news_email)
    ){
      errors.news_email = 'Invalid your email';
    }
    return errors;
}
export const validatnew = (inputs) => {
    const errors = {};
    if (!inputs.email) {
      errors.email = 'Please enter your email';
    }else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputs.email)
    ){
      errors.email = 'Invalid your email';
    }
    return errors;
}
export const validatecontact = (inputs) => {
    const errors = {};
	if (!inputs.first_name) {
      errors.first_name = 'Please enter first name';
    }
	if (!inputs.last_name) {
      errors.last_name = 'Please enter last name';
    }
	if (!inputs.message) {
      errors.message = 'Please enter message';
    }
	
    if (!inputs.email) {
      errors.email = 'Please enter your email';
    }else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputs.email)
    ){
      errors.email = 'Invalid your email';
    }
    return errors;
}
export const validatemember = (member) => {
  const errors = {
    first_name: {},
    last_name: {},
    email: {},
    phone_number: {},
    age: {},
  };

  member.forEach((val) => {
    const ticketId = val.ticket_id;
    const no = val.no;

    if (!errors.first_name[ticketId]) errors.first_name[ticketId] = {};
    if (!errors.last_name[ticketId]) errors.last_name[ticketId] = {};
    if (!errors.email[ticketId]) errors.email[ticketId] = {};
    if (!errors.phone_number[ticketId]) errors.phone_number[ticketId] = {};
    if (!errors.age[ticketId]) errors.age[ticketId] = {};

    if (val.first_name === '') {
      errors.first_name[ticketId][no] = 'Please enter first name';
    }
    if (val.last_name === '') {
      errors.last_name[ticketId][no] = 'Please enter last name';
    }
    if (val.email === '') {
      errors.email[ticketId][no] = 'Please enter email';
    }else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(val.email)
    ){
      errors.email[ticketId][no] ='Invalid your email';
    }
    if (val.phone_number === '') {
      errors.phone_number[ticketId][no] = 'Please enter phone number';
    }
    if (val.age === '') {
      errors.age[ticketId][no] = 'Please enter age';
    }
  });

  return errors;
};
export const validatequestion = (member) => {
  const errors = {
    question: {},
  };

  member.forEach((val) => {
    const ticketId = val.ticket_id;
    const no = val.no;

       
    // Initialize nested objects
    if (!errors.question[ticketId]) {
      errors.question[ticketId] = {};
    }
    if (!errors.question[ticketId][no]) {
      errors.question[ticketId][no] = {};
    }

    val.question.forEach((val1) => {
      const id = val1.id;
       const is_required = val1.is_required;
       if(is_required)
       {
        if (val1.type === 'multiple_choice') {
          if (val1.option_val === 0 || val1.option_val === '') {
            errors.question[ticketId][no][id] = 'Please select an option.';
          }
        } else {
          if (val1.answer_text === '') {
            errors.question[ticketId][no][id] = 'Please enter an answer.';
          }
        }
      }
    });
  });

  return errors;
};
export const validatecheckout = (inputs) => {
    const errors = {};
	if (!inputs.email) {
      errors.email = 'Please enter your email';
    }else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputs.email)
    ){
      errors.email = 'Invalid your email';
    }
	if (!inputs.first_name) {
      errors.first_name = 'Please enter first name';
    }
	if (!inputs.last_name) {
      errors.last_name = 'Please enter last name';
    }	

    if(inputs.single_event)
    {
        if (!inputs.location) {
          errors.location = 'Please select location';
        }
        if (!inputs.gender) {
          errors.gender = 'Please select gender';
        }
        if (!inputs.birth_year) {
          errors.birth_year = 'Please select birth year';
        }  
    }

    return errors;
}
export const validatecheckoutnew = (inputs) => {
    const errors = {};
  if (!inputs.email) {
      errors.email = 'Please enter your email';
    }else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputs.email)
    ){
      errors.email = 'Invalid your email';
    }
  if (!inputs.first_name) {
      errors.first_name = 'Please enter first name';
    }
  if (!inputs.last_name) {
      errors.last_name = 'Please enter last name';
    } 
    if (inputs.accept_terms===0) {
      errors.accept_terms = 'Please select terms and conditions';
    } 
    return errors;
}
export const validatejoinwaitlist = (inputs) => {
    const errors = {};
	if (!inputs.first_name) {
      errors.first_name = 'Please enter first name';
    }
	if (!inputs.last_name) {
      errors.last_name = 'Please enter last name';
    }
    if (!inputs.email) {
      errors.email = 'Please enter your email';
    }else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputs.email)
    ){
      errors.email = 'Invalid your email';
    }
	if (!inputs.phone_number) {
      errors.phone_number = 'Please enter phone number';
    }
    if (!inputs.age) {
      errors.age = 'Please enter age';
    }
    if (!inputs.gender) {
      errors.gender = 'Please enter gender';
    }
    return errors;
}

export const validateForm = (inputs) => {
    const errors = {};
    inputs.forEach((input) => {
        const { field, label, rules, value } = input;
        const ruleArray = rules.split('|');
        ruleArray.some((rule) => {
            const [ruleName, ruleValue] = rule.split(':');
            switch (ruleName) {
                case 'required':
                    if (!value || value.trim() === '') {
                        errors[field] = `${label} is required`;
                        return true; // Stop checking other rules for this field
                    }
                    break;
                case 'valid_email':
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!emailRegex.test(value)) {
                        errors[field] = `${label} must be a valid email address`;
                        return true;
                    }
                    break;
                case 'min':
                    if (value.length < parseInt(ruleValue, 10)) {
                        errors[field] = `${label} should be at least ${ruleValue} characters long`;
                        return true;
                    }
                    break;
                case 'max':
                    if (value.length < parseInt(ruleValue, 10)) {
                        errors[field] = `${label} must be at most ${ruleValue} characters`;
                        return true;
                    }
                    break;
                case 'matches':
                    const otherField = ruleValue;
                    if (value !== inputs.find((input) => input.field === otherField)?.value) {
                        errors[field] = `${label} must match with ${otherField}`;
                        return true;
                    }
                    break;
                case 'number':
                    // const numberRegex = /^(0|[1-9][0-9]*)$/;
                    const numberRegex = /^\+?[1-9]\d{6,14}$/;
                    if (!numberRegex.test(value)) {
                        errors[field] = `Invalid ${label && (label).toLowerCase()}`;
                        return true;
                    }
                    break;
                case 'strong_password':
                    const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
                    if (!passwordRegex.test(value)) {
                        errors[field] = `${label} must be a strong password`;
                        return true;
                    }
                    break;
                case 'max_words':
                    const words = value.trim().split(/\s+/).filter(Boolean);
                    const currentWordCount = words.length;
                    if (currentWordCount > ruleValue) {
                        errors[field] = `${label} must be at most ${ruleValue} words`;
                        return true;
                    }
                    break;
                default:
                    break;
            }
            return false; // Continue checking other rules for this field
        });
    });
    return errors;
};
export const validateproductcheckout = (inputs) => {
    const errors = {};
    
  if (!inputs.email) {
      errors.email = 'Please enter your email';
    }else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputs.email)
    ){
      errors.email = 'Invalid your email';
    }
    if (!inputs.first_name) {
      errors.first_name = 'Please enter first name';
    }
    if (!inputs.last_name) {
      errors.last_name = 'Please enter last name';
    }
    if (!inputs.mobile_number) {
      errors.mobile_number = 'Please enter mobile number';
    }
   if (!inputs.country_id) {
      errors.country_id = 'Please select country';
    }
    if (!inputs.county) {
      errors.county = 'Please enter county';
    }
    if (!inputs.address) {
      errors.address = 'Please enter street address';
    }
    if (!inputs.postcode) {
      errors.postcode = 'Please enter postcode';
    }

    if(inputs.single_event)
    {
        if (!inputs.location) {
          errors.location = 'Please select location';
        }
        if (!inputs.gender) {
          errors.gender = 'Please select gender';
        }
        if (!inputs.birth_year) {
          errors.birth_year = 'Please select birth year';
        }  
    }

    return errors;
}
export const validatecheckeventpassword = (inputs) => {
    const errors = {};
  if (!inputs.password) {
      errors.password = 'Please enter password';
    }
  
    return errors;
}